import type { RequestInfo } from '@warp-drive/core/types/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

/**
 * PATCH /people/:id/contribution-account — reorder the person's
 * contribution accounts. Body is the legacy JSON:API shape the server
 * expects (singular `person` type with snake_case attribute key).
 */
export function updateContributionAccountRequest(
  personId: string,
  accountIds: string[]
): RequestInfo {
  const opts: QueryUrlOptions = {
    identifier: { type: 'people' },
    op: 'query',
    resourcePath: 'people',
  };
  return {
    url: `${buildBaseURL(opts)}/${personId}/contribution-account`,
    method: 'PATCH',
    body: JSON.stringify({
      data: {
        type: 'person',
        id: personId,
        attributes: { account_order: accountIds },
      },
    }),
    cacheOptions: { [SkipCache]: true },
  };
}

/**
 * GET /people/:id/slr-alerts — student-loan-refinance alerts for a person.
 * Returns a plain JSON payload (not JSON:API); the caller casts the response
 * `content` to its `SlrAlertsResponse` shape.
 */
export function getSlrAlertsRequest(personId: string): RequestInfo {
  const opts: QueryUrlOptions = {
    identifier: { type: 'people' },
    op: 'query',
    resourcePath: 'people',
  };
  return {
    url: `${buildBaseURL(opts)}/${personId}/slr-alerts`,
    method: 'GET',
    cacheOptions: { [SkipCache]: true },
  };
}
